// Curated Content Management Actions
export const CURATED_CONTENT_ACTION_STARTS = 'CURATED_CONTENT_ACTION_STARTS';
export const CURATED_CONTENT_ACTION_ERRORS = 'CURATED_CONTENT_ACTION_ERRORS';

// Get all curated contents
export const GET_ALL_CURATED_CONTENTS = 'GET_ALL_CURATED_CONTENTS';
export const GET_CURATED_CONTENT_BY_ID = 'GET_CURATED_CONTENT_BY_ID';

// Create, Update, Delete curated contents
export const CREATE_CURATED_CONTENT = 'CREATE_CURATED_CONTENT';
export const UPDATE_CURATED_CONTENT = 'UPDATE_CURATED_CONTENT';
export const DELETE_CURATED_CONTENT = 'DELETE_CURATED_CONTENT';

// Action creators
export const curatedContentActionStarts = () => ({
  type: CURATED_CONTENT_ACTION_STARTS,
});

export const curatedContentActionErrors = (error: string) => ({
  type: CURATED_CONTENT_ACTION_ERRORS,
  payload: error,
});

export const getAllCuratedContentsAction = (contents: any[]) => ({
  type: GET_ALL_CURATED_CONTENTS,
  payload: contents,
});

export const getCuratedContentByIdAction = (content: any) => ({
  type: GET_CURATED_CONTENT_BY_ID,
  payload: content,
});

export const createCuratedContentAction = (content: any) => ({
  type: CREATE_CURATED_CONTENT,
  payload: content,
});

export const updateCuratedContentAction = (content: any) => ({
  type: UPDATE_CURATED_CONTENT,
  payload: content,
});

export const deleteCuratedContentAction = (contentId: string) => ({
  type: DELETE_CURATED_CONTENT,
  payload: contentId,
});
